import React from 'react'

const ScoreCardSetting = () => {
    return (
        <div>ScoreCardSetting</div>
    )
}

export default ScoreCardSetting